//Checking for reference, storing it to local if so.

let service;
let address_json_type;

/**
 * used only in this block
 * @param {String} parameterName
 * @returns {String|null}
 */
var findGetParameter = (parameterName) => {
  var result = null,
    tmp = [];
  var items = location.search.substr(1).split("&");
  for (var index = 0; index < items.length; index++) {
    tmp = items[index].split("=");
    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
  }
  return result;
};

$(document).ready(function () {
  $(".address-search .address").keyup(
    delay(function () {
      var $this = $(this),
        form = $(".address-search");

      if ($this.val()?.length > 3) {
        form.submit();
      }
    }, 500)
  );
  $("body").on("submit", ".address-search", function (e) {
    e.preventDefault();

    var $this = $(this),
      address = $this.find("input[name=address]").val();

    search_for_address(address);
  });
  $("body").on("click", ".select-address", function (e) {
    e.preventDefault();

    var $this = $(this),
      address_id = $this.data("id"),
      address_title = $this.data("title"),
      address_json = $this.data("json");

    select_this_address(address_id, address_title, address_json);
  });
  $("body").on("click", ".change-address", function (e) {
    e.preventDefault();

    var $this = $(this),
      address_form = $(".address-search"),
      address_selected = $(".address-selected");

    address_selected.fadeOut();
    address_form.find(".change-address-cont").fadeOut();
    address_form.find(".address").val("").focus();
  });
  $("body").on("click", ".check-address", function (e) {
    e.preventDefault();

    var $this = $(this),
      address_id = $this.data("id"),
      address_title = $this.data("title"),
      address_json = $this.data("json");

    check_this_address(address_id, address_title, address_json);
  });
  $("body").on("click", ".revert-address,.clear-address", function (e) {
    e.preventDefault();

    var address_selected = $(".address-selected"),
      address_results = $(".address-search-results"),
      address_form = $(".address-search"),
      services_banner = $(".services-banner"),
      services_floating = $(".services-floating"),
      services_plans = $(".services-plans"),
      from = $("body").data("from");

    if (localStorage.getItem("registered_service") != "" || localStorage.getItem("registered_service") !== null) {
      from = localStorage.getItem("registered_service");
    }

    // check if has registered address
    if (localStorage.getItem(from + "_my_registered_address") == "" || localStorage.getItem(from + "_my_registered_address") === null) {
      alert("Something went wrong!!!");
    } else {
      localStorage.setItem("registered_service", "");
      localStorage.setItem(from + "_my_registered_address", "");
      localStorage.setItem(from + "_my_registered_address_json", "");
      localStorage.setItem(from + "_has_line", "");
      services_floating.find(".address").html("");
      services_floating.slideUp();
      services_banner.slideDown();
      services_plans.css("padding-top", 0);
      updatePrice();
    }
  });
  // $('#successModal').on('hidden.bs.modal', function(e) {
  // 	if ($('#typeModal').length) {
  // 		$('#typeModal').modal('show');
  // 	}
  // });
  $(".phone-line").on("click", function (e) {
    e.preventDefault();

    var $this = $(this),
      has_line = $this.data("has-line"),
      from = $("body").data("from");

    localStorage.setItem(from + "_has_line", has_line);
    $("body").attr("data-line", has_line);
    if (has_line == false) {
      var items = $(".plans .category .item");
      items.removeClass("active");
      $(".itembundle").addClass("active");
      updatePrice();
    }
  });
  $("body").on("click", ".choose-plan", function (e) {
    e.preventDefault();

    var $this = $(this),
      bundle = $(".plans .category .item .active").data("is-bundle"),
      plan = $this.data("plan"),
      from = $("body").data("from"),
      error_modal = $("#errorModal"),
      type_modal = $("#typeModal"),
      sync_modal = $("#syncModal");

    if (localStorage.getItem("registered_service") != "" || localStorage.getItem("registered_service") !== null) {
      service = localStorage.getItem("registered_service");
    }

    if (localStorage.getItem(service + "_my_registered_address") == "" || localStorage.getItem(service + "_my_registered_address") === null) {
      error_modal.modal("show");
    } else {
      var address_json_data = $.parseJSON(localStorage.getItem(service + "_my_registered_address")),
        address_json_type = $.parseJSON(localStorage.getItem(service + "_my_registered_address_json")),
        address = address_json_data.address ? address_json_data.address : address_json_data.fullAddress,
        gnafId = address_json_data.id ? address_json_data.id : address_json_data.gnafId,
        type = address_json_type.serviceClassInfo ? address_json_type.serviceClassInfo.displayName.split("(") : [""];

      if (from != service && service != "manual" && !redirectFromNbnToAdsl(address_json_type.serviceClass, address_json_type.technologyType)) {
        const classCode = (address_json_type.serviceClassInfo.classCode ? address_json_type.serviceClassInfo.classCode : '');
        const classTitle = classCodes[classCode] ? classCodes[classCode].title : '';


        sync_modal.find(".title span").text(service);
        sync_modal.find(".type span").text(classTitle);
        sync_modal.find(".btn-" + service).fadeIn();
        if (classCodes[classCode] !== undefined) {
          var moreInfo = sync_modal.find(".type").children(".more-info");
          sync_modal.find(".type span").text(classCodes[classCode].title);
          moreInfo.find(".box .title").text(classCodes[classCode].title);
          moreInfo.find(".box .desc").text(classCodes[classCode].desc);
          moreInfo.fadeIn();
        }
        sync_modal.modal("show");
      } else {
        //Ref variable
        var materef = "";
        if (typeof getCookie("mate_ref_id") === "string") {
          materef = "&ibo=" + getCookie("mate_ref_id");
        }

        if (typeof getCookie("mate_jaicon_id") === "string") {
          materef += "&jcon=666";
        }

        // If ADSL check line first
        if (service == "adsl" && (localStorage.getItem(service + "_has_line") == "" || localStorage.getItem(service + "_has_line") === null)) {
          type_modal.modal("show");
        } else if (service == "manual") {
          // check if adsl then change
          // from variable base from
          // has line
          var line = "";
          if (service == "adsl") {
            line = $("body").attr("data-line").toString() === "true" ? "adsl-existing" : "adsl-new";
            service = line;
          }
          // ?from=adsl-existing&address=undefined&serviceClass=zone3&newDevelopmentFee=FALSE&productChoice=mate-adsl-country-mates-bundle&addressId=240213211&gnafId=undefined&bundle=undefined&sqFail=false&isManualFail=false
          // ?from=adsl-existing&address=as%20as%20sd%20sd%20sd%20sd%20sd&serviceClass=3&newDevelopmentFee=FALSE&productChoice=mate-adsl-country-mates-bundle&addressId=undefined&gnafId=undefined&bundle=undefined&sqFail=true&isManualFail=true
          var url =
            "/orders/?from=adsl-existing&address=" +
            encodeURIComponent(address) +
            "&serviceClass=" +
            // + encodeURIComponent(address_json_type.serviceClass)
            encodeURIComponent(
              redirectFromNbnToAdsl(address_json_data.serviceClass, address_json_data.technologyType)
                ? plan === "mate-adsl-city-mates-bundle"
                  ? "zone1"
                  : "zone3"
                : address_json_type.serviceClass
            ) +
            "&newDevelopmentFee=FALSE&productChoice=" +
            encodeURIComponent(plan) +
            "&addressId=" +
            encodeURIComponent(address_json_type.addressId) +
            "&gnafId=" +
            encodeURIComponent(gnafId) +
            "&bundle=" +
            encodeURIComponent(bundle) +
            "&sqFail=true&isManualFail=true" +
            materef;

          window.open(url, "_blank");
        } else {
          // check if adsl then change
          // from variable base from
          // has line
          var line = "";
          if (service == "adsl" || redirectFromNbnToAdsl(address_json_data.serviceClass, address_json_data.technologyType)) {
            if (redirectFromNbnToAdsl(address_json_data.serviceClass, address_json_data.technologyType)) {
              line = "adsl-new";
            } else {
              line = $("body").attr("data-line").toString() === "true" ? "adsl-existing" : "adsl-new";
            }

            service = line;
          }
          // address_json_type.serviceClass
          // So bundle is only the
          // thing to check.
          // console.log(bundle);
          //
          // console.log(localStorage);
          var url =
            "/orders/?from=" +
            encodeURIComponent(service) +
            "&address=" +
            encodeURIComponent(address) +
            "&serviceClass=" +
            // + encodeURIComponent(address_json_type.serviceClass)
            encodeURIComponent(
              redirectFromNbnToAdsl(address_json_data.serviceClass, address_json_data.technologyType)
                ? plan === "mate-adsl-city-mates-bundle"
                  ? "zone1"
                  : "zone3"
                : address_json_type.serviceClass
            ) +
            "&newDevelopmentFee=FALSE&productChoice=" +
            encodeURIComponent(plan) +
            "&addressId=" +
            encodeURIComponent(address_json_type.addressId) +
            "&gnafId=" +
            encodeURIComponent(gnafId) +
            "&bundle=" +
            encodeURIComponent(bundle) +
            "&sqFail=false&isManualFail=false" +
            materef;
          //console.log(url);
          window.open(url, "_blank");
        }
      }
    }
  });

  $("body").on("click", ".address-required", function (e) {
    e.preventDefault();

    var $this = $(this),
      address_form = $(".address-search"),
      services_banner = $(".services-banner");

    $("html, body").animate(
      {
        scrollTop: services_banner.offset().top - $("header").outerHeight(),
      },
      500
    );
  });

  regionalLogic();
});

function regionalLogic() {
  if (localStorage.getItem("registered_service") != "" || localStorage.getItem("registered_service") !== null) {
    service = localStorage.getItem("registered_service");
    address_json_type = $.parseJSON(localStorage.getItem(service + "_my_registered_address_json"));
    if (service != "manual") {
      if (address_json_type != null) {
        if (redirectFromNbnToAdsl(address_json_type.serviceClass, address_json_type.technologyType)) {
          // do nothing
        } else if (address_json_type.serviceClass == "zone1") {
          $(".is_regional").hide();
        } else {
          $(".is_city").hide();
        }
      }
    }
  }
}

function search_for_address(address) {
  var address_results = $(".address-search-results"),
    address_selected = $(".address-selected");

  $.ajax({
    type: "GET",
    url: ajax_url,
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    data: {
      action: "search_for_address",
      address: address,
    },
    success: function (resp) {
      address_selected.fadeOut();
      address_results.html(resp.data);
      address_results.slideDown();
    },
  });
}

function select_this_address(id, title, json) {
  var address_selected = $(".address-selected"),
    address_results = $(".address-search-results"),
    address_form = $(".address-search");

  $.ajax({
    type: "GET",
    url: ajax_url,
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    data: {
      action: "select_this_address",
      id: id,
      title: title,
      json: json,
    },
    success: function (resp) {
      address_form.find(".change-address-cont").fadeIn();
      address_results.slideUp();
      address_selected.html(resp.data);
      address_selected.fadeIn();
    },
  });
}
function check_this_address(id, title, json) {
  var address_selected = $(".address-selected"),
    address_results = $(".address-search-results"),
    address_form = $(".address-search"),
    services_banner = $(".services-banner"),
    services_floating = $(".services-floating"),
    services_plans = $(".services-plans"),
    success_modal = $("#successModal"),
    reject_modal = $("#rejectModal"),
    sync_modal = $("#syncModal"),
    from = $("body").data("from");
  if (from == "nbn_new") {
    from = "nbn";
  }
  $.ajax({
    type: "GET",
    url: ajax_url,
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    data: {
      action: "check_this_address",
      id: id,
      title: title,
      json: json,
      from: from,
    },
    beforeSend: function () {
      $(".loader").fadeIn();
    },
    success: function (resp) {
      $(".loader").fadeOut();
      var json_data = $.parseJSON(resp.data),
        json_type = $.parseJSON(resp.json);
      var type = [""];
      if (json_type.serviceClassInfo && json_type.serviceClassInfo.displayName) {
        type = json_type.serviceClassInfo.displayName.split("(");
      }

      // Setting the defaults
      if (json_type.newDevelopmentFee == "TRUE") {
        // $("#feemodal").modal("show");
        sync_modal.find(".newdev").show();
        success_modal.find(".newdev").show();
      } else {
        // $("#feemodal").modal("hide");
        sync_modal.find(".newdev").hide();
        success_modal.find(".newdev").hide();
      }

      sync_modal.find(".status").text("success!");

      sync_modal.find(".desc").text("it looks like your place uses");

      //sync_modal
      //.find('.title')
      //.text('is available');
      sync_modal.find(".title").text("");

      sync_modal.find(".title").prepend("<span></span> ");

      success_modal.find(".desc").text("it looks like your place uses");

      sync_modal.find(".btn-nbn").hide();
      sync_modal.find(".btn-adsl").hide();
      // End defaults

      if ("serviceClassInfo" in json_type && "classCode" in json_type["serviceClassInfo"]) {
        var service_description = "";
        if (json_type["serviceClassInfo"]["classCode"] in serviceClasses) {
          service_description = serviceClasses[json_type["serviceClassInfo"]["classCode"]];
        }
        sync_modal.find(".timeframe").html(service_description);
        success_modal.find(".timeframe").html(service_description);
      } else {
        sync_modal.find(".timeframe").text("");
        success_modal.find(".timeframe").text("");
      }

      // type = json_type.serviceClassInfo ?
      // json_type.serviceClassInfo.displayName.split("(") : [''];

      const classCode = (json_type.serviceClassInfo.classCode ? json_type.serviceClassInfo.classCode : '');
      const classTitle = classCodes[classCode] ? classCodes[classCode].title : '';


      if (resp.qualified == "PASS") {

        const modalDefaultStatus = "success!";
        const modalDefaultBackgroundImage = "url(/includes/assets/img/webp/services/modal/success-person.webp)";
        const modalDefaultButtonText = "continue";
        const modalDefaultButtonLink = "https://www.letsbemates.com.au/nbn/";
        success_modal.find(".img-before").css("background-image", modalDefaultBackgroundImage);
        success_modal.find(".img-before").css("background-size", "unset");
        success_modal.find(".img-before").css("background-position-x", "unset");
        success_modal.find(".img-before").css("background-position-y", "unset");
        success_modal.find(".status").html(modalDefaultStatus);
        success_modal.find(".type").show();
        success_modal.find(".timeframe").html(service_description);
        success_modal.find(".btn-yellow").attr("href", modalDefaultButtonLink);
        success_modal.find(".btn-yellow").attr("data-bs-dismiss", "");
        success_modal.find(".btn-yellow").html(modalDefaultButtonText);

        var type = json_type.serviceClassInfo ? json_type.serviceClassInfo.displayName.split("(") : "",
          address = json_data.address ? json_data.address : json_data.fullAddress;

        success_modal.find(".type span").text(classTitle);

        if (json_type["serviceType"] == "ADSL") {
          success_modal.find(".title").text("nbn™ might be available");
          success_modal.find(".desc").text("give us a call on 13 14 13 to check nbn™ availability or continue with an adsl order below");
        } else {
          success_modal.find(".title").text("nbn™ is available");
        }
        // if (json_type.newDevelopmentFee == "TRUE") {
        //     $("#feemodal").on("hidden.bs.modal", function (e) {
        //         success_modal.modal("show");
        //     });
        // } else {
        success_modal.modal("show");
        // }
        if (classCodes[classCode] !== undefined) {
          var moreInfo = success_modal.find(".type").children(".more-info");
          success_modal.find(".type span").text(classCodes[classCode].title);
          moreInfo.find(".box .title").text(classCodes[classCode].title);
          moreInfo.find(".box .desc").text(classCodes[classCode].desc);
          moreInfo.fadeIn();
        }

        const classTitle = classCodes[classCode] ? classCodes[classCode].title : '';

        localStorage.setItem("registered_service", resp.from);
        localStorage.setItem(resp.from + "_my_registered_address", resp.data);
        localStorage.setItem(resp.from + "_my_registered_address_json", resp.json);
        address_form.find(".change-address-cont").hide();
        address_results.html("").hide();
        address_selected.html("").hide();
        services_floating.find(".address").html(address);
        services_floating.find(".type").html(classTitle);
        services_floating.slideDown();
        services_banner.slideUp();
        setTimeout(function () {
          // services_plans.css("padding-top", services_floating.outerHeight());
        }, 300);
      } else if (resp.qualified == "MULTIPLE") {
        var addresses = resp.addresses;
        format_multiple_addresses(addresses, resp.from);
      } else {
        reject_modal.modal("show");
      }
    },
  });
}

function format_multiple_addresses(addresses, from) {
  var address_results = $(".address-search-results"),
    address_selected = $(".address-selected"),
    reject_modal = $("#rejectModal");

  $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "format_multiple_addresses",
      addresses: addresses,
      from: from,
    },
    success: function (resp) {
      resp = $.parseJSON(resp);
      if (resp.from == "nbn" || resp.from == "adsl") {
        address_selected.fadeOut();
        address_results.html(resp.data);
        address_results.slideDown();
      } else {
        reject_modal.modal("show");
      }
    },
  });
}

/**
 * Plans =====================================
 */
$("body").on("click", ".plans .category .item", function () {
  var $this = $(this),
    is_bundle = $this.data("is-bundle"),
    items = $(".plans .category .item");

  if (!$this.hasClass("active")) {
    items.removeClass("active");
    $this.addClass("active");
    // plan.find('.choose-plan').attr('data-bundle',
    // is_bundle);
    updatePrice();
  }
});

function updatePrice() {
  // Comment this if already dynamic
  $(".plans .plan").each(function () {
    var $this = $(this),
      mobile_current_price = parseInt($this.find(".mobile-head .price .amount").text(), 10),
      current_price = parseInt($this.find(".head .price .amount").text(), 10),
      plan_type = $(".plans .category .item.active").data("is-bundle"),
      mobile_price_con = $this.find(".mobile-head .price .amount"),
      price_con = $this.find(".head .price .amount"),
      bundle_price = parseInt($this.find(".head .price .bundle_value").text(), 10),
      new_price = 0,
      mobile_new_price = 0;

    if (plan_type == true) {
      $(".is_bundled").show();
      $(".is_unbundled").hide();
    } else {
      $(".is_bundled").hide();
      $(".is_unbundled").show();
    }
  });
  // End of comment this
  regionalLogic();
}
